import { render } from "./user-identification.vue?vue&type=template&id=a854b460&ts=true"
import script from "./user-identification.vue?vue&type=script&lang=ts"
export * from "./user-identification.vue?vue&type=script&lang=ts"

import "./user-identification.vue?vue&type=style&index=0&id=a854b460&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__